<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        item-key="id"
        :footer-props="footerOptions"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-toolbar-title v-html="title" />
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-text-field
              v-model="search"
              label="Buscar"
              single-line
              hide-details
            />
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-btn
              v-if="can('crear_sucursal_empresa')"
              :color="themeColor"
              class="white--text"
              @click="newItem()"
            >
              Nuevo Registro
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.active="{ item }">
        <v-switch
          :color="themeColor"
          v-model="item.active"
          :loading="toggleStatus"
          @click.prevent="openModalStatus(item)"
        />
      </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template
              v-slot:activator="{ on }"
            >
              <v-icon
                v-if="can('crear_punto_empresa')"
                :color="themeColor"
                @click="openModalShow(item)"
                v-on="on"
              >
                mdi-layers-plus
              </v-icon>
            </template>
            <span>Crear Punto de Facturación</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('editar_sucursal_empresa')"
                :color="themeColor"
                @click="editItem(item)"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="!readonly && can('eliminar_sucursal_empresa')"
                :color="themeColor"
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                @click="showPtoFac(item)"
                v-on="on"
              >
                mdi-crosshairs-gps
              </v-icon>
            </template>
            <span>Punto de Facturación</span>
          </v-tooltip>
        </template>
        <template v-slot:footer>
          <slot />
        </template>
        <template v-slot:no-data>
          <v-label>No se encontraron resultados.</v-label><br>
          <v-btn
            :color="themeColor"
            @click="reset"
          >
            Limpiar búsqueda
          </v-btn>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialogStatus"
        max-width="750"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres cambiar el estado de este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogStatus = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="toggleActive()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog"
        max-width="620"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres eliminar este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusDelete"
              @click.prevent="deleteItem()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogShow"
        max-width="400"
      >
        <v-card>
          <v-card-title class="headline">
            Crear Punto de Facturación
          </v-card-title>
          <v-container>
            <v-form
              ref="form"
              lazy-validation
              @submit.prevent="reset"
              @keydown="form.onKeydown($event)"
            >
              <v-card-text>
                <v-text-field
                  v-model="form.code_point"
                  label="Código"
                  :rules="[rules.required, rules.codeLength]"
                  maxlength="3"
                  @change="searchCodePoint"
                  required
                />
              </v-card-text>
              <v-card-text>
                <v-text-field
                  v-model="form.description"
                  label="Descripción"
                  :rules="[rules.required]"
                  required
                />
              </v-card-text>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialogShow = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="form.busy"
              @click.prevent="createPtoFact()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';

export default {
  middleware: 'auth',
  props: {
    apiURL: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    form: new Form({
      id: '',
      code_point: '',
      description: '',
      status: 1,
      active: 1,
      busy: false,
    }),
    search: '',
    items: [],
    totalItems: 0,
    loading: false,
    footerOptions: {},
    dialog: false,
    dialogShow: false,
    options: {},
    message: '',
    type: '',
    dialogStatus: false,
    toggleStatus: false,
    toggleStatusDelete: false,
    headers: [
      {
        text: 'Código',
        value: 'code',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Nombre',
        value: 'description',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'active',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
    name: '',
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      codeLength: (v) => v.length === 3 || 'El campo debe tener de 3 caracteres numéricos.',
    },
  }),
  computed: {
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
  },
  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.can('cambiar_estado_sucursal_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
  },
  methods: {
    refreshTable() {
      this.getDataFromApi()
      .then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
      });
    },
    getDataFromApi() {
      this.loading = true;

      return new Promise(async (resolve) => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage,
        } = this.options;
        const response = await this.getItems(page, itemsPerPage, sortBy, sortDesc).then((response) => {
            const data = response.data.items;
            const { total } = response.data;
            return ({ data, total } || []);
        });
        const items = response.data;
        const { total } = response;

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total,
          });
        }, 1000);
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}&search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    newItem() {
      this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
    },
    editItem(item) {
      const editedItem = { ...item };
      this.$router.push({ path: `${this.$router.currentRoute.path}/${editedItem.id}/editar`, params: { id: editedItem.id } });
    },
    showPtoFac(item) {
      this.$router.push({ path: `${this.$router.currentRoute.path}/${item.id}/punto`, params: { id: item.id } });
    },
    reset() {
      this.search = '';
    },
    openModalStatus(item) {
      this.dialogStatus = true;
      this.item = item;
    },
    toggleActive() {
      this.toggleStatus = true;
      const url = `${this.apiURL}/${this.item.id}/toggle`;
      window.axios.post(url)
        .then((response) => {
          this.refreshTable();
          this.toggleStatus = false;
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.type = response.data.type;
          this.dialogStatus = false;
          this.item.active = !this.item.active;
        });
    },
    openModalDelete(item) {
       this.dialog = true;
       this.item = item;
      },
    deleteItem() {
      this.toggleStatusDelete = true;
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.toggleStatusDelete = false;
        this.dialog = false;
        this.getDataFromApi()
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.form.busy = true;
        this.store();
      }
    },
    store() {
      this.form.busy = true;
      const url = `${this.apiURL}/${this.item.id}/point/store`;
      window.axios.post(url, {
        id_subsidiary: this.item.id,
        code_point: this.form.code_point,
        description: this.form.description,
        status: this.form.status,
        active: this.form.active,
      })
      .then((response) => {
        this.message = response.data.message;
        this.type = response.data.type;
        this.dialogShow = false;
        this.form.busy = false;
        this.refreshTable();
      });
    },
    createPtoFact() {
      this.validate();
    },
    openModalShow(item) {
      this.dialogShow = true;
      this.item = item;
    },
    searchCodePoint() {
      if (this.form.code_point) {
        const url = `${this.apiURL}/${this.item.id}/point/getPto/${this.form.code_point}`;
        window.axios.get(url)
        .then((response) => {
          if (response.data.code_point === 500) {
            this.form.code_point = '';
          }
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
        });
      }
    },
  },
};
</script>
